import apiClient, { handleAxiosError } from "./apiClient";

export const subscribeNewsletter = async (email: string) => {
	try {
		const response = await apiClient.post("/newsletter", { email });
		return response.data;
	} catch (error) {
		handleAxiosError(error);
		throw new Error("Failed to subscribe to newsletter");
	}
};
